/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ProductStagingQualityDTO interface.
 */
export function instanceOfProductStagingQualityDTO(value) {
    return true;
}
export function ProductStagingQualityDTOFromJSON(json) {
    return ProductStagingQualityDTOFromJSONTyped(json, false);
}
export function ProductStagingQualityDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'flag': json['flag'] == null ? undefined : json['flag'],
        'productCount': json['productCount'] == null ? undefined : json['productCount'],
        'avgBSR': json['avgBSR'] == null ? undefined : json['avgBSR'],
        'avgProfit': json['avgProfit'] == null ? undefined : json['avgProfit'],
    };
}
export function ProductStagingQualityDTOToJSON(json) {
    return ProductStagingQualityDTOToJSONTyped(json, false);
}
export function ProductStagingQualityDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'marketplace': value['marketplace'],
        'flag': value['flag'],
        'productCount': value['productCount'],
        'avgBSR': value['avgBSR'],
        'avgProfit': value['avgProfit'],
    };
}
